import styled from 'styled-components';
import { AllieButton } from '../Buttons/Button';
import { AllieModal } from '../Modal/Modal';

export const StyledModal = styled(AllieModal)`
  --border-radius: 8px;
`;

export const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--allie-color-neutral-10);
  padding: 20px 32px 16px 32px;
`;

export const StyledCloseButton = styled(AllieButton)`
  --border-color: var(--allie-color-neutral-20);
  --border-radius: 8px;
  --background: white;
`;

export const ContentContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const Container = styled.div`
  max-height: 90vh;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledFooter = styled.footer`
  display: flex;
  flex-flow: row-reverse;
  padding: 20px 32px 19px 20px;
`;
